import { Routes } from '@angular/router';
import { HomeComponent } from './layout/home/home.component';
import { HeaderComponent } from './layout/header/header.component';
import { PolicyRouteComponent } from './layout/home/policy-route.component';

export const routes: Routes = [
  {
    path: '',
    component: HeaderComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
        data: { title: 'home' },
        children: [
          {
            path: 'policies/:slug',
            component: PolicyRouteComponent,
          },
        ],
      },
      {
        path: 'home',
        component: HomeComponent,
        data: { title: 'home' },
      }
    ],
  },
];
